import script from "./AddWithFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./AddWithFeedback.vue?vue&type=script&setup=true&lang=js"

import "./AddWithFeedback.vue?vue&type=style&index=0&id=2bd53fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd53fca"]])

export default __exports__